import styled from 'styled-components';

const ShareStyle = styled.section`
	--iconSizes: var(--sp4x);

	display: flex;
	align-items: center;
	flex-direction: column;

	.share-icon {
		font-size: var(--iconSizes);

		&.is-copied {
			pointer-events: none;
			color: green;
		}
	}

	.links-wrap {
		display: flex;
		flex-direction: column;

		.share-link {
			width: var(--iconSizes);
			height: var(--iconSizes);
			margin-top: var(--sp2-5x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--iconSizes: var(--sp3x);

		align-items: flex-start;

		.links-wrap {
			display: flex;
			flex-direction: row;
			margin-top: var(--sp2x);

			.share-link {
				margin-top: var(--sp2x);
				margin-top: unset;
				margin-right: var(--sp2-5x);
			}
		}
	}
`;

export default ShareStyle;
